export function createThemedStyles(stylesCreator) {
    return function (theme) { return stylesCreator(theme); };
}
